import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'webhook', namespaced: true })

export default mystore
